export const red = '#d83713';
export const orange = '#FFB400';
export const green = '#009D8A';
export const grey = '#EBEBEB';
